import { LoadableAfterPaint } from '@confluence/loadable';

export const EndOfPageRecommendationLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndOfPageRecommendation" */ './EndOfPageRecommendation'
			)
		).EndOfPageRecommendation,
});
